import { Asset } from '../types/asset.interface';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';

export const assetDefinition: EntityDefinition<Asset> = {
  entityType: 'Asset',
  i18nBase: 'entities.asset',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.asset.fields.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'assetTypeId',
        headerKey: 'entities.asset.fields.type',
        storeType: 'AssetType',
        displayField: 'name',
        template: 'tag',
        class: 'min-w-50',
      },
      {
        field: 'documentationUrl',
        headerKey: 'entities.asset.fields.documentationUrl',
        template: 'externalLinkButton',
        hidden: false,
      },
    ],
  },
  rowLinkHref: entity => `/assets/${entity.id}`,
  fields: [
    { field: 'name', labelKey: 'entities.asset.fields.name', required: true, type: 'text', minLength: 3, maxLength: 50 },
    { field: 'assetTypeId', labelKey: 'entities.asset.fields.type', required: true, type: 'select', storeType: 'AssetType' },
    {
      field: 'documentationUrl',
      labelKey: 'entities.asset.fields.documentationUrl',
      required: false,
      type: 'text',
      minLength: 3,
      maxLength: 2048,
    },
  ],
  validationFields: ['name'],
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: Asset) => !entity.hasMeasure,
      errorMessageKey: 'entities.asset.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: Asset, store) => {
        if (!store) return true;
        const entities = store.getData<Asset>('Asset')();
        return !entities.some(g => g.name.toLowerCase().trim() === entity.name.toLowerCase().trim());
      },
      errorMessageKey: 'entities.asset.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: Asset, store) => {
        if (!store) return true;
        const entities = store.getData<Asset>('Asset')();
        return !entities.some(g => g.name.toLowerCase().trim() === entity.name.toLowerCase().trim() && g.id !== entity.id);
      },
      errorMessageKey: 'entities.asset.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.asset.messages.createTitle',
      edit: () => 'entities.asset.messages.editTitleWithName',
      delete: () => 'entities.asset.messages.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.asset.messages.addButton',
      create: () => 'entities.asset.messages.addButton',
      edit: () => 'entities.asset.messages.editTitleWithName',
      delete: () => 'entities.asset.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.asset.messages.deleteConfirm',
  },
};
